/* eslint-disable camelcase */
import React, { useContext, useEffect, useState } from 'react'
import { ScrollView, Text, View } from 'react-native'
import { TemplatePage } from '../../../components/TemplatePage'
import { globalStyle } from '../../../theme/global'
import { TextInputComponent } from '../../../components/TextInputComponent'
import { Separator } from '../../../components/Separator'
import { corporateColor, lightBackground, textColor, toqueColor } from '../../../theme/colors'
import { Card } from './components/Card'
import { Button } from '../../../components/Button'
import { StackNavigationProp } from '@react-navigation/stack'
import { RootParams } from '../../../navigator/types'
import { useNavigation } from '@react-navigation/native'
import { useGet } from '../../../hooks/useGet'
import { ConsumptionReq, ConsumptionRes, FuelTankReq, InitialData, NavalArtifactReq } from './types'
import { paths } from '../../../api/pathsApi'
import { FuelContext } from '../../../context/Logistics/fuel/FuelProvider'
import { usePost } from '../../../hooks/usePost'
import { AuthContext } from '../../../context/Auth/AuthContext'
import { AlertMessage } from '../../../components/AlertMessage'
import { Alert401 } from '../../../components/AlertMessage/Alert401'

const FIRST_ELEMENT = 0
export const FuelConsumption = () => {
  const navigation = useNavigation<StackNavigationProp<RootParams, 'LogisticsStack'>>()
  const {
    params: { centers },
  } = useContext(FuelContext)
  const { user, handleLogOut } = useContext(AuthContext)

  const [alerts, setAlerts] = useState({
    duplicated: false,
    success: false,
  })
  const [navalArtifactReq, setNavalArtifactReq] = useState<{
    [navalArtifactId: number]: NavalArtifactReq
  }>({})

  const {
    initialData,
    getInitialData,
    codeError: codeErrGetData,
  } = useGet<InitialData>({
    url: centers[0] ? paths().LOGISTIC.INITIAL_CONSUMPTION(centers[0].id) : '',
    enabled: false,
    cleanCache: false,
  })

  useEffect(() => {
    if (centers[FIRST_ELEMENT]) getInitialData()
  }, [centers])

  const { handleSendData, codeError, msgError } = usePost<ConsumptionReq, ConsumptionRes>({
    url: paths().LOGISTIC.CREATE_CONSUMPTION(centers[FIRST_ELEMENT]!.id),
    onSuccess(data) {
      navigation.replace('LogisticsStack', { screen: 'Success', params: data })
    },
    onError(error) {
      if (error.code === 409) {
        setAlerts((prev) => ({ ...prev, duplicated: true }))
      }
    },
  })

  const handleConfirmConsumption = (checkDuplicated: boolean) => {
    handleSendData({
      check_duplicated: checkDuplicated,
      date_consumption: initialData?.current_date ?? '',
      id_user: user.userId!,
      naval_artifacts: Object.values(navalArtifactReq),
    })
  }

  const isButtonDisabled = (): boolean => {
    return Object.values(navalArtifactReq).some(
      (artifact) => artifact.fuel_consumption === 0 || isTankDataInvalid(artifact.fuel_tanks),
    )
  }

  const isTankDataInvalid = (fuelTanks: FuelTankReq[]): boolean => {
    const expectedTankLengths = initialData?.naval_artifacts.map(
      (artifact) => artifact.fuel_tanks.length,
    )
    if (!expectedTankLengths) return true

    return expectedTankLengths.every((expectedLength) => {
      if (expectedLength !== fuelTanks.length) return true
      return fuelTanks.some((tank) => tank.stock === '' || tank.stock === '0')
    })
  }

  return (
    <TemplatePage styleContent={{ padding: 0, marginBottom: 0 }} header title='Consumo combustible'>
      <ScrollView
        style={[
          globalStyle.viewContainer,
          { paddingHorizontal: 16, backgroundColor: lightBackground },
        ]}
      >
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingHorizontal: 16,
            marginBottom: 8,
          }}
        >
          <View style={{ flex: 1 }}>
            <Text style={{ color: corporateColor }}>Centro: {initialData?.name}</Text>
            <Separator
              customStyle={{ borderColor: toqueColor, borderWidth: 2, width: 31, marginTop: 4 }}
            />
          </View>
          <TextInputComponent
            onChange={() => null}
            value={initialData?.current_date ?? ''}
            readonly
            customStyles={{
              container: { flex: 0.8 },
              input: { marginTop: 0 },
            }}
          />
        </View>

        {initialData?.naval_artifacts.map((item, index) => (
          <Card
            key={item.id_naval_artifact + index}
            item={item}
            onChange={(values) =>
              setNavalArtifactReq((prev) => {
                return {
                  ...prev,
                  [item.id_naval_artifact]: values,
                }
              })
            }
          />
        ))}

        <View style={{ alignItems: 'center', marginBottom: 48 }}>
          <Button
            label='Volver'
            onPress={() => navigation.replace('HomeScreen')}
            variant='white'
            customStyle={{ width: 200 }}
          />
          <Button
            label='Confirmar consumo'
            onPress={() => handleConfirmConsumption(true)}
            customStyle={{ width: 200 }}
            disabled={isButtonDisabled()}
          />
        </View>
      </ScrollView>

      {alerts.duplicated && (
        <AlertMessage
          title='Registro Duplicado'
          successLabel='Si, Guardar'
          cancelLabel='Cancelar'
          cancelButton
          actionCancelButton={() => setAlerts((prev) => ({ ...prev, duplicated: false }))}
          action={() => {
            handleConfirmConsumption(false)
            setAlerts((prev) => ({ ...prev, duplicated: false }))
          }}
        >
          <Text style={{ textAlign: 'center', color: textColor }}>
            El registro que intenta guardar ya existe. ¿Desea guardarlo de todas formas?
          </Text>
        </AlertMessage>
      )}

      {codeError === 400 && (
        <AlertMessage title='Error' successLabel='Ok'>
          <Text style={{ textAlign: 'center', color: textColor }}>{msgError}</Text>
        </AlertMessage>
      )}

      <Alert401 isRender={codeError === 401 || codeErrGetData === 401} action={handleLogOut} />
    </TemplatePage>
  )
}
